import React from 'react';
import OrderGenieV2 from './OrderXV2';

const OrderGenieV3 = () => {
  return <OrderGenieV2 variant="v3" />;
};

export default OrderGenieV3;
